import StepNavigationBase from '@components/StepNavigation'

// @ts-expect-error TS2307
import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

interface StepNavigationProps {
  assignLayoutTemplatePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const StepNavigation = (props: StepNavigationProps) => {
  const {
    assignLayoutTemplatePermissionsPayload: {
      activeStepKey,
      callbacks: { setCurrentStepKey },
      payloads: {
        publications: { reduxActionPerformed: publicationsLoaded },
        publicationProducts: { reduxActionPerformed: publicationProductsLoaded },
      },
      permissions: { queued: queuedPermissions },
    },
  } = props

  return (
    <StepNavigationBase
      activeStepKey={activeStepKey}
      callbacks={{
        setCurrentStepKey: ({ key }) => setCurrentStepKey(key),
      }}
      steps={[
        {
          key: 'publicationIds',
          label: 'Publications',
          body: publicationsLoaded ? `${queuedPermissions.publicationIds.length} Assigned` : 'Click to Load',
        },
        {
          key: 'publicationProductIds',
          label: 'Publications Product',
          body: publicationProductsLoaded ? `${queuedPermissions.publicationProductIds.length} Assigned` : 'Click to Load',
        },
      ]}
    />
  )
}

export default StepNavigation
